module.exports = __webpack_public_path__ + "static/media/bg-auth-pages.2299cd77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-auth-pages.jpg
// module id = 306
// module chunks = 0